import ApiGetOptions from '@/datatypes/api-get-options';
import ApiPostOptions from '@/datatypes/api-post-options';
import ApiDeleteOptions from '@/datatypes/api-delete-options';
import ApiPutOptions from '@/datatypes/api-put-options';
import ApiService from '@/services/api/ApiService';
import decamelizeKeysDeep from 'decamelize-keys-deep';

export default class BillingCustomerService extends ApiService {
  public searchCustomer(enterpriseId, params) {
    return this.call(new ApiGetOptions(
      {
        url: `/enterprises/${enterpriseId}/billing_customers`,
        params: decamelizeKeysDeep(params),
      },
    ));
  }

  public assignCustomer(enterpriseId, params) {
    return this.call(new ApiPostOptions(
      {
        url: `/enterprises/${enterpriseId}/billing_customers/assign`,
        data: decamelizeKeysDeep(params),
      },
    ));
  }

  public fetchCustomer(enterpriseId) {
    return this.call(new ApiGetOptions(
      {
        url: `/enterprises/${enterpriseId}/billing_customer`,
      },
    ));
  }

  public updateCustomer(enterpriseId, params) {
    return this.call(new ApiPutOptions(
      {
        url: `/enterprises/${enterpriseId}/billing_customer`,
        data: decamelizeKeysDeep(params),
      },
    ));
  }

  public removeCustomer(enterpriseId) {
    return this.call(new ApiDeleteOptions(
      {
        url: `/enterprises/${enterpriseId}/billing_customer`,
      },
    ));
  }

  public createCustomer(enterpriseId, params) {
    return this.call(new ApiPostOptions(
      {
        url: `/enterprises/${enterpriseId}/billing_customer`,
        data: decamelizeKeysDeep(params),
      },
    ));
  }
}
